
import React, { useState, useEffect } from 'react';
import DashboardLayout from '@/components/layout/DashboardLayout';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Skeleton } from '@/components/ui/skeleton';
import { AlertCircle } from 'lucide-react';

const PowerBIReport = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  
  useEffect(() => {
    // Simulate loading
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);
    
    return () => clearTimeout(timer);
  }, []);

  const handleIframeError = () => {
    setHasError(true);
    setIsLoading(false);
  };

  return (
    <DashboardLayout>
      {/* Page Header */}
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-800 dark:text-white">Power BI Reports</h1>
        <p className="text-gray-500 dark:text-gray-400 mt-2">
          Interactive analytics and business intelligence reports
        </p>
      </div>

      {/* Report Container */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-4 mb-8">
        {isLoading ? (
          <div className="w-full space-y-4">
            <Skeleton className="h-12 w-1/3" />
            <Skeleton className="h-[500px] w-full rounded-md" />
          </div>
        ) : hasError ? (
          <Alert variant="destructive">
            <AlertCircle className="h-4 w-4" />
            <AlertDescription>
              There was a problem loading the Power BI report. Please try again later or contact support.
            </AlertDescription>
          </Alert>
        ) : (
          <div className="h-[800px] w-full">
            <iframe 
              title="HBC" 
              width="100%" 
              height="100%" 
              src="https://app.powerbi.com/reportEmbed?reportId=dd65041b-a340-47d8-8d23-ddfebf65a9a8&autoAuth=true&ctid=b24752cf-dca1-4cd9-8094-aeeb93913ea5" 
              frameBorder="0" 
              allowFullScreen={true}
              onError={handleIframeError}
              className="w-full h-full"
            />
          </div>
        )}
      </div>

    </DashboardLayout>
  );
};

export default PowerBIReport;
